import { render, staticRenderFns } from "./PurchasingPaymentModal.vue?vue&type=template&id=700b5b66"
import script from "./PurchasingPaymentModal.vue?vue&type=script&lang=js"
export * from "./PurchasingPaymentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports